import { useEffect, useRef, useState } from "react";
import { Formik } from "formik";
import { useNavigate } from "react-router-dom";
import { Slide, ToastContainer, toast } from "react-toastify";
import { DefaultLayout } from "../../layouts/Default";
import { Main } from "../../themes/Default/components/Main";
import { Tabs } from "../../themes/Default/components/Tabs";
import { TopNavigation } from "../../themes/Default/components/TopNavigation";
import { Breadcrumps } from "../../themes/Default/components/Breadcrumps";
import { Link } from "../../themes/Default/components/Breadcrumps/components/Link";
import { Button, ButtonBack } from "../../themes/Default/components/TopNavigation/components/Button";
import { Form } from "../../themes/Default/components/Form";
import { Row } from "../../themes/Default/components/Form/components/Row";
import { Field } from "../../themes/Default/components/Form/components/Row/components/Field";
import { Input } from "../../themes/Default/components/Form/components/Input";
import { Select } from "../../themes/Default/components/Form/components/Select";
import { studentsManagement } from "../../hooks/api/StudentsManagement";
import { prepareSelect } from "../../services/core/Select";
import { useTranslation } from "react-i18next";
import Divider from "../../themes/Default/components/Divider/Divider";
import DatePicker from "../../themes/Default/components/Form/components/DatePicker/DatePicker";
import { locationsManagement } from "../../hooks/api/LocationsManagement";
import { callsManagement } from "../../hooks/api/CallsManagement";
import { settingsCallManagement } from "../../hooks/api/SettingsCallManagement";
import { Textarea } from "../../themes/Default/components/Form/components/Textarea";
import { languagesManagement } from "../../hooks/api/LanguagesManagement/LanguagesManagement";

const AddCall = () => {
    const { t } = useTranslation("common");
    const formRef = useRef(null);
    const navigate = useNavigate();
    const [formErrors, setFormErrors] = useState([]);

    const { useAddCallMutation } = callsManagement;
    const [addCall] = useAddCallMutation();

    const [locations, setLocations] = useState([]);
    const { useLocationListMutation } = locationsManagement;
    const [locationsList] = useLocationListMutation();

    const [studentStatus, setStudentStatus] = useState([]);
    const { useStudentStatusListMutation } = settingsCallManagement;
    const [studentStatusList] = useStudentStatusListMutation();

    const [status, setStatus] = useState([]);
    const { useStatusListMutation } = settingsCallManagement;
    const [statusList] = useStatusListMutation();

    const [courseType, setCourseType] = useState([]);
    const { useCourseTypeListMutation } = settingsCallManagement;
    const [courseTypeList] = useCourseTypeListMutation();

    const [appointment, setAppointment] = useState([]);
    const { useAppointmentListMutation } = settingsCallManagement;
    const [appointmentList] = useAppointmentListMutation();

    const [salesChannel, setSalesChannel] = useState([]);
    const { useSalesChannelListMutation } = settingsCallManagement;
    const [salesChannelList] = useSalesChannelListMutation();

    const [methodOfContact, setMethodOfContact] = useState([]);
    const { useMethodOfContactListMutation } = settingsCallManagement;
    const [methodOfContactList] = useMethodOfContactListMutation();

    const [offerSent, setOfferSent] = useState([]);
    const { useOfferSentListMutation } = settingsCallManagement;
    const [offerSentList] = useOfferSentListMutation();

    const [language, setLanguage] = useState([]);
    const { useLanguageListMutation } = languagesManagement;
    const [languageList] = useLanguageListMutation();

    const [students, setStudents] = useState([]);
    const { useStudentsListMutation } = studentsManagement;
    const [studentsList] = useStudentsListMutation();

    const formatDateToDMY = (date) => {
        if (!date) return ""; 
        const d = new Date(date);
        if (isNaN(d.getTime())) {
            return "";
        }
        const day = String(d.getDate()).padStart(2, "0");
        const month = String(d.getMonth() + 1).padStart(2, "0");
        const year = d.getFullYear();
        return `${day}.${month}.${year}.`;
    };
    
    const todayDMY = formatDateToDMY(new Date());

    const convertDMYtoISO = (dmY) => {
        const [day, month, year] = dmY.split(".").map((p) => p.trim());
        if (!day || !month || !year) return "";
        return `${year}-${month.padStart(2,"0")}-${day.padStart(2,"0")}`;
    };

    const tabs = [{ title: t("details"),  isActive: true }];

    const onSave = () => {
        if (formRef.current) {
            formRef.current.handleSubmit();
        }
    };

    const onSaved = (values) => {
        const body = {
            ...values,
            date: convertDMYtoISO(values.date),
        };
        addCall(body).then((result) => {
            if (result?.error) {
                setFormErrors(result?.error?.data?.error?.violations);
                toast.error(result.error.data.error.responseMessage);
            } else {
                navigate("/calls/edit/" + result?.data?.id);
            }
        });
    };

    useEffect(() => {
        locationsList().then((result) => {
            let options = [];
            result?.data?.records.map((location) => {
                options.push({
                    id: location.id,
                    name: location.name,
                });
            });
            setLocations(prepareSelect(options));
        });

        studentStatusList().then((result) => {
            let options = [];
            result?.data?.records.map((studentStatus) => {
                options.push({
                    id: studentStatus.id,
                    name: studentStatus.status,
                });
            });
            setStudentStatus(prepareSelect(options));
        });

        statusList().then((result) => {
            let options = [];
            result?.data?.records.map((status) => {
                options.push({
                    id: status.id,
                    name: status.status,
                });
            });
            setStatus(prepareSelect(options));
        });

        courseTypeList().then((result) => {
            let options = [];
            result?.data?.records.map((courseType) => {
                options.push({
                    id: courseType.id,
                    name: courseType.name,
                });
            });
            setCourseType(prepareSelect(options));
        });

        appointmentList().then((result) => {
            let options = [];
            result?.data?.records.map((appointment) => {
                options.push({
                    id: appointment.id,
                    name: appointment.name,
                });
            });
            setAppointment(prepareSelect(options));
        });

        salesChannelList().then((result) => {
            let options = [];
            result?.data?.records.map((salesChannel) => {
                options.push({
                    id: salesChannel.id,
                    name: salesChannel.name,
                });
            });
            setSalesChannel(prepareSelect(options));
        });

        methodOfContactList().then((result) => {
            let options = [];
            result?.data?.records.map((methodOfContact) => {
                options.push({
                    id: methodOfContact.id,
                    name: methodOfContact.name,
                });
            });
            setMethodOfContact(prepareSelect(options));
        });

        offerSentList().then((result) => {
            let options = [];
            result?.data?.records.map((offerSent) => {
                options.push({
                    id: offerSent.id,
                    name: offerSent.name,
                });
            });
            setOfferSent(prepareSelect(options));
        });

        languageList().then((result) => {
            let options = [];
            result?.data?.records.map((language) => {
                options.push({
                    id: language.id,
                    name: language.name,
                });
            });
            setLanguage(prepareSelect(options));
        });

        studentsList().then((result) => {
            let options = [];
            result?.data?.records.map((student) => {
                options.push(
                    {
                        id: student.id,
                        firstName: student.firstName,
                        lastName: student.lastName,
                        dateOfBirth: student.dateOfBirth,
                        name: student.firstName + " " + student.lastName + " " + student.dateOfBirth,
                        guardian1FirstName: student.guardian1FirstName,
                        guardian1LastName: student.guardian1LastName,
                        guardian1PhoneNumber: student.guardian1PhoneNumber,
                        guardian1Email: student.guardian1Email,
                        grade: student.grade,
                    }
                );
            })
            setStudents(prepareSelect(options));
        });
    }, []);

    return (
        <DefaultLayout>
            
            <TopNavigation>
                <ButtonBack to="/calls" />
                <Button title={t("save")} icon="fa-regular fa-floppy-disk" onClick={onSave}></Button>
            </TopNavigation>
            <Tabs tabs={tabs} />
            <Main>
                <Breadcrumps>
                    <Link title={t("calls.title")} icon="fa-user-graduate" />
                    <Link title={t("calls.add")} isActive={true} />
                </Breadcrumps>
                <Formik
                    innerRef={formRef}
                    initialValues={{
                        firstName: "",
                        lastName: "",
                        dateOfBirth: "",
                        note: "",
                        grade: "",
                        guardian1FirstName: "",
                        guardian1LastName: "",
                        guardian1PhoneNumber: "",
                        guardian1Email: "",
                        date: todayDMY,
                        studentStatus: "",
                        status: "",
                        courseType: "",
                        appointment: "",
                        location: "",
                        salesChannel: "",
                        methodOfContact: "",
                        offerSent: ""
                    }}
                    onSubmit={onSaved}
                >
                    {({ values, handleChange, setFieldValue }) => (
                        <Form>
                            <Row>
                                <Field>
                                    <Select
                                        name="student"
                                        label={t("calls.student")}
                                        options={students}
                                        onChange={(e) => {
                                            handleChange(e);
                                            const selectedStudent = students.find(s => s.id === e.target.value);
                                            console.log("DOB from student:", selectedStudent.dateOfBirth);
                                            if (selectedStudent) {
                                              setFieldValue("firstName", selectedStudent.firstName || "");
                                              setFieldValue("lastName", selectedStudent.lastName || "");
                                              setFieldValue("dateOfBirth", convertDMYtoISO(selectedStudent.dateOfBirth || ""));
                                              setFieldValue("guardian1FirstName", selectedStudent.guardian1FirstName || "");
                                              setFieldValue("guardian1LastName", selectedStudent.guardian1LastName || "");
                                              setFieldValue("guardian1PhoneNumber", selectedStudent.guardian1PhoneNumber || "");
                                              setFieldValue("guardian1Email", selectedStudent.guardian1Email || "");
                                              setFieldValue("grade", selectedStudent.grade || "");
                                            }
                                        }}
                                        selectedValue={values.student}
                                        error={formErrors?.student}
                                        searchInDropdown={false}
                                    />
                                </Field>
                                <Field>
                                    <DatePicker
                                        name="date"
                                        label={t("test.date")}
                                        required={true}
                                        value={values.date}
                                        onChange={(e) => {
                                            const isoDate = e.target.value;
                                            const d = new Date(isoDate);
                                            if (!isNaN(d.getTime())) {
                                                const day = String(d.getDate()).padStart(2, "0");
                                                const month = String(d.getMonth() + 1).padStart(2, "0");
                                                const year = d.getFullYear();
                                                setFieldValue("date", `${day}.${month}.${year}.`);
                                            } else {
                                                setFieldValue("date", "");
                                            }
                                        }}
                                        error={formErrors?.date}
                                    />
                                </Field>
                            </Row>
                            <Divider title={t("students.guardian1")} />
                            <Row>
                                <Field>
                                    <Input
                                        name="guardian1FirstName"
                                        label={t("employees.firstName")}
                                        value={values.guardian1FirstName}
                                        onChange={handleChange}
                                        error={formErrors?.guardian1FirstName}
                                    />
                                </Field>
                                <Field>
                                    <Input
                                        name="guardian1LastName"
                                        label={t("employees.lastName")}
                                        value={values.guardian1LastName}
                                        onChange={handleChange}
                                        error={formErrors?.guardian1LastName}
                                    />
                                </Field>
                            </Row>
                            <Row>
                                <Field>
                                    <Input
                                        name="guardian1Email"
                                        label={t("employees.email")}
                                        value={values.guardian1Email}
                                        onChange={handleChange}
                                        error={formErrors?.guardian1Email}
                                    />
                                </Field>
                                <Field>
                                    <Input
                                        name="guardian1PhoneNumber"
                                        label={t("employees.phoneNumber")}
                                        required={true}
                                        value={values.guardian1PhoneNumber}
                                        onChange={handleChange}
                                        error={formErrors?.guardian1PhoneNumber}
                                    />
                                </Field>
                            </Row>
                            <Divider title={t("calls.call")} />
                            <Row>
                                <Field>
                                    <Select
                                        name="status"
                                        label={t("status")}
                                        required={true}
                                        options={status}
                                        onChange={handleChange}
                                        selectedValue={values.status}
                                        error={formErrors?.status}
                                        searchInDropdown={false}
                                    />
                                </Field>
                                <Field>
                                    <Select
                                        name="language"
                                        label={t("program.language")}
                                        options={language}
                                        onChange={handleChange}
                                        selectedValue={values.language}
                                        error={formErrors?.language}
                                        searchInDropdown={false}
                                    />
                                </Field>
                            </Row>
                            <Row>
                                <Field>
                                    <Input
                                        name="firstName"
                                        label={t("students.firstName")}
                                        value={values.firstName}
                                        onChange={handleChange}
                                        error={formErrors?.firstName}
                                    />
                                </Field>
                                <Field>
                                    <Input
                                        name="lastName"
                                        label={t("students.lastName")}
                                        value={values.lastName}
                                        onChange={handleChange}
                                        error={formErrors?.lastName}
                                    />
                                </Field>
                            </Row>
                            <Row>
                                <Field>
                                    <DatePicker
                                        name="dateOfBirth"
                                        label={t("students.dateOfBirth")}
                                        value={values.dateOfBirth}
                                        onChange={handleChange}
                                        error={formErrors?.dateOfBirth}
                                    />
                                </Field>
                                <Field>
                                    <Input
                                        name="grade"
                                        label={t("students.grade")}
                                        value={values.grade}
                                        onChange={handleChange}
                                        error={formErrors?.grade}
                                    />
                                </Field>
                            </Row>
                            {/* <Row>
                                <Field>
                                    <Select
                                        name="salesChannel"
                                        label={t("calls.saleChannel")}
                                        required={true}
                                        options={salesChannel}
                                        onChange={handleChange}
                                        selectedValue={values.salesChannel}
                                        error={formErrors?.salesChannel}
                                        searchInDropdown={false}
                                    />
                                </Field>
                                <Field>
                                    <Select
                                        name="offerSent"
                                        label={t("calls.offerSent")}
                                        required={true}
                                        options={offerSent}
                                        onChange={handleChange}
                                        selectedValue={values.offerSent}
                                        error={formErrors?.offerSent}
                                        searchInDropdown={false}
                                    />
                                </Field>
                            </Row> */}
                            <Row>
                                <Field>
                                    <Select
                                        name="appointment"
                                        label={t("groups.classStartTime")}
                                        options={appointment}
                                        onChange={handleChange}
                                        selectedValue={values.appointment}
                                        error={formErrors?.appointment}
                                        searchInDropdown={false}
                                    />
                                </Field>
                                <Field>
                                    <Select
                                        name="location"
                                        label={t("groups.location")}
                                        options={locations}
                                        onChange={handleChange}
                                        selectedValue={values.location}
                                        error={formErrors?.location}
                                        searchInDropdown={false}
                                    />
                                </Field>
                            </Row>
                            <Row>
                                <Field>
                                    <Select
                                        name="studentStatus"
                                        label={t("calls.old/new")}
                                        required={true}
                                        options={studentStatus}
                                        onChange={handleChange}
                                        selectedValue={values.studentStatus}
                                        error={formErrors?.studentStatus}
                                        searchInDropdown={false}
                                    />
                                </Field>
                                <Field>
                                    <Select
                                        name="methodOfContact"
                                        label={t("calls.methodOfContacts")}
                                        required={true}
                                        options={methodOfContact}
                                        onChange={handleChange}
                                        selectedValue={values.methodOfContact}
                                        error={formErrors?.methodOfContact}
                                        searchInDropdown={false}
                                    />
                                </Field>
                            </Row>
                            {/* <Row>
                                <Field>
                                    <Select
                                        name="courseType"
                                        label={t("students.contractGroupType")}
                                        required={true}
                                        options={courseType}
                                        onChange={handleChange}
                                        selectedValue={values.courseType}
                                        error={formErrors?.courseType}
                                        searchInDropdown={false}
                                    />
                                </Field>
                            </Row> */}
                            <Row>
                                <Field isFullWidth={true}>
                                    <Textarea
                                        name="note"
                                        label={t("calendar.note")}
                                        onChange={handleChange}
                                        value={values.note}
                                        rows={10}
                                        error={formErrors?.note}
                                    />
                                </Field>
                            </Row>
                        </Form>
                    )}
                </Formik>
            </Main>
        </DefaultLayout>
    );
};

export default AddCall;
